import React from 'react';

const Row = ({ country, cpc }) => {
    return (
        <tr>
            <td>{cpc}</td>
            <td>{country}</td>
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/PushapiCpc/components/Table/components/Row/index.js